'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

/* Stores */

var _storesModuleInspector = require('stores/module-inspector');

var _storesModuleInspector2 = _interopRequireDefault(_storesModuleInspector);

/* Components */

var _componentsUiTextField = require('components/ui/text-field');

var _componentsUiTextField2 = _interopRequireDefault(_componentsUiTextField);

exports['default'] = _react2['default'].createClass({
  displayName: 'text',

  render: function render() {
    var props = this.props;

    var translate = _storesModuleInspector2['default'].translate;
    var baseName = props.groupName + '_' + props.name;
    var placeholderText = translate(baseName);

    return _react2['default'].createElement(_componentsUiTextField2['default'], {
      value: props.value || '',
      ref: 'textfield',
      disabled: props.disabled,
      placeholder: placeholderText,
      description: placeholderText,
      onChange: this._onChange });
  },

  _onChange: function _onChange(evt) {
    var props = this.props;
    var value = this.refs.textfield.value;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/text.js
 **/